const isNullable = (value) => value === null || value === undefined;
const isNumerical = (value) => !Number.isNaN(+value);
const isBoolean = (value) => typeof value === "boolean";
const isString = (value) => typeof value === "string";
const isSymbol = (value) => typeof value === "symbol";
const isNumber = (value) => typeof value === "number";
const isBigInt = (value) => typeof value === "bigint";
const isFunction = (value) => typeof value === "function";
const isObject = (value) => value !== null && typeof value === "object";
const isPlainObject = (value) => {
	if (!isObject(value)) {
		return false;
	}
	const p = Object.getPrototypeOf(value);
	return p === Object.prototype || p === null;
};
const isWeakKey = (value) => isSymbol(value) || isObject(value) || isFunction(value);
const isPropertyKey = (value) => isString(value) || isSymbol(value) || isNumber(value);
const isPrimitive = (value) => !isObject(value) && !isFunction(value);
const isArray = Array.isArray;
const isArrayLike = (value) => isArray(value) || isObject(value) && isNumber(value.length);
const isTemplateStringArray = (value) => isArray(value) && isArray(value.raw);
const isConstructor = (value) => isFunction(value) && value.prototype.constructor === value;
const asyncFnCons = (async () => {}).constructor;
const isAsyncFunction = (value) => isFunction(value) && value.constructor === asyncFnCons;
const generatorFnCons = function* () {}.constructor;
const isGeneratorFunction = (value) => isFunction(value) && value.constructor === generatorFnCons;
const asyncGeneratorFnCons = async function* () {}.constructor;
const isAsyncGeneratorFunction = (value) => isFunction(value) && value.constructor === asyncGeneratorFnCons;
const isIterable = (value) => isObject(value) && isFunction(value[Symbol.iterator]);
const isAsyncIterable = (value) => isObject(value) && isFunction(value[Symbol.asyncIterator]);
const isThenable = (value) => (isObject(value) || isFunction(value)) && isFunction(value.then);
const isPromise = (value) => value instanceof Promise || isThenable(value) && isFunction(value.catch);

export { isArray, isArrayLike, isAsyncFunction, isAsyncGeneratorFunction, isAsyncIterable, isBigInt, isBoolean, isConstructor, isFunction, isGeneratorFunction, isIterable, isNullable, isNumber, isNumerical, isObject, isPlainObject, isPrimitive, isPromise, isPropertyKey, isString, isSymbol, isTemplateStringArray, isThenable, isWeakKey };
//# sourceMappingURL=is.js.map
